var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('rj-tabs',{model:{value:(_vm.tabsActive),callback:function ($$v) {_vm.tabsActive=$$v},expression:"tabsActive"}},[_c('rj-tab-pane',{attrs:{"name":"1","label":"电汇查询"}},[_c('remittance-list')],1),_c('rj-tab-pane',{attrs:{"name":"2","label":"已申请退款查询"}},[_c('refund-query')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }